
export interface IRuleViolation {
	message: string;
	fieldNames: string[];
}

export interface IDispatcherResult {
	status: number;
	failureMessages: IRuleViolation[];
	data: unknown;
}

export interface IDispatcherResultTyped<T> {
	status: number;
	failureMessages: IRuleViolation[];
	data: T;
}

export class Validator {
	public static isEmail (value: string): boolean {
		const pattern = '^([a-zA-Z0-9_\\-\\.\\+]+)@' +
			'((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|' +
			'(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$';

		const regex = new RegExp(pattern);

		return typeof value === 'string' && value.length < 256 && regex.test(value);
	}
}
